module.exports = __webpack_public_path__ + "img/Forklift-warehouse-2-1200-COMPRESSED.94877e89.gif";